<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="['Product_ProductPriceGroup_Management']">
		<template #badges>
			<nk-badge system="sale"></nk-badge>
		</template>

		<div class="group-list h-100">
			<div class="row no-gutters h-100">
				<div class="group-list col col-8 h-100 pl-1">
					<div class="card nk-card p-0 h-100">
						<div class="card-header">
							{{ $t('sale.product-price-group-list.information') }}
						</div>
						<div class="card-body h-100">
							<nk-tree ref="treeview" :options="componentOptions.productPriceGroupTree" :data="filteredItems" :selected="selectedProductPriceGroup" @setSelected="setSelectedProductPriceGroup" :tabindex="201" startup>
							</nk-tree>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import ProductPriceGroupModify from './product-price-group-modify'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { mapActions, mapGetters } from 'vuex'
	import { isEmpty } from '~/statics/validators'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'

	export default {
		modal: {
			size: 'md',
			stateUID: 'product-price-group-list',
			helpTag: 'ProductPriceGroupList'
		},
		props: {
			options: { type: Object },
			data: { type: Object },
		},
		data() {
			return {
				selectedProductPriceGroup: null,
				componentOptions: {
					productPriceGroupTree: {
						enableSearch: true,
						editable: true,
						searchResultText: this.$t('msg.number-of-items-found'),
						onNodeAddClicked: this.addChildProductPriceGroup,
						onNodeEditClicked: this.editProductPriceGroup,
						onNodeDeleteClicked: this.deleteProductPriceGroup,
						deletePolicyClaims: 'Product_ProductPriceGroup_Delete',
						editPolicyClaims: 'Product_ProductPriceGroup_Edit',
						searchPlaceholder: this.$t(
							'sale.product-price-group-list.search-placeholder'
						),
						defaultSortByFields: ['level', 'code'],
					},
				},
				treeNodes: [],
				productPriceGroupInfo: {
					nodeData: null,
					parentData: null,
					state: '',
				},
				selectPriceGroupButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter-only'),
					element: () => this.$refs.treeview.$el,
					icon: 'check',
					isPrimary: true,
					visible: (this.options || {}).selectable,
					handle: (button, page, e) => {
						this.resolve(this.selectedProductPriceGroup)
					}
				},
				insertPriceGroupButton: {
					title: this.$t('sale.product-price-group.insert'),
					shortcut: $sc.find('new'),
					isPrimary: false,
					icon: 'plus',
					handle: (button, page, e) => {
						this.addRootProductPriceGroup()
					},
					policyClaims: 'Product_ProductPriceGroup_Add',
				},
			}
		},
		computed: {
			...mapGetters({
				all: 'productPriceGroups/all'
			}),
			filteredItems() {
				return (this.treeNodes || []).sort((a, b) => {
					let res = a.level - b.level
					if (res === 0) {
						return a.id - b.id
					} else {
						return res
					}
				})
			},
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			this.getProductPriceGroupData()

			let buttonsArray
			if (this.grandParentType() === 'modal') {
				buttonsArray = [this.selectPriceGroupButton, this.insertPriceGroupButton]
			} else {
				this.selectPriceGroupButton.visible = false
				buttonsArray = [this.insertPriceGroupButton]
			}

			this.prepareWindow(this.$t('sale.product-price-group-list.title'), buttonsArray)
		},
		methods: {
			...mapActions({
				refresh_productPriceGroups: 'productPriceGroups/refresh',
			}),
			fillNodes(node) {
				let index = this.treeNodes.findIndex((x) => x.id === node.id)
				if (index === -1) {
					this.treeNodes = [...this.treeNodes, node]
				} else {
					this.treeNodes.splice(index, 1, node)
				}

				let parent = node.parent == null ? null : _.head(this.treeNodes.filter((x) => x.id === node.parent.id))

				if (parent != null && !parent.hasChild) {
					parent.hasChild = true
				}
			},
			async getProductPriceGroupData(force = false) {
				var wait = this.$wait(this.$refs.treeview.$el)
				await this.refresh_productPriceGroups({ force: force })
				wait.end()
				this.treeNodes = _.cloneDeep(this.all)
				this.selectedProductPriceGroup = _.head(this.filteredItems)
			},
			setSelectedProductPriceGroup(productPriceGroup) {
				this.selectedProductPriceGroup = productPriceGroup
			},
			addRootProductPriceGroup() {
				var productData = {
					id: emptyId,
					parent: null,
					code: this.findMaxChildCode(null) + 1,
					name: '',
					hasChild: false,
					isEnabled: true,
					description: '',
					level: 1,
					accountingCode: '',
					position: null,
					group: null,
					centerCategory: null,
				}

				this.addTreeNode(productData, null)
			},
			addChildProductPriceGroup(parent) {
				var productData = {
					id: emptyId,
					parent,
					code: this.findMaxChildCode(parent.id) + 1,
					name: '',
					hasChild: false,
					isEnabled: true,
					description: '',
					level: Number(parent.level) + 1,
					accountingCode: '',
					position: parent.position,
					group: parent.group,
					centerCategory: null,
				}

				this.addTreeNode(productData, parent)
			},
			addTreeNode(newNode, parent) {
				this.productPriceGroupInfo.nodeData = typeof newNode === 'undefined' ? null : newNode
				this.productPriceGroupInfo.parentData = parent
				this.productPriceGroupInfo.parentScope = this
				this.productPriceGroupInfo.state = parent ? 'add-child' : 'add-root'

				this.showModal({
					component: ProductPriceGroupModify,
					data: this.productPriceGroupInfo,
				})
					.then((node) => {
						this.refresh_productPriceGroups({ force: true })
						this.selectedProductPriceGroup = node
						this.fillNodes(node)
						this.$refs.treeview.$el.focus()
					})
					.catch(() => {
						this.$refs.treeview.$el.focus()
					})
			},
			editProductPriceGroup(node) {
				var nodeData = $.extend(true, {}, node)
				var parentData = this.getParentNodeById(
					nodeData.parent ? nodeData.parent.id : null
				)

				this.productPriceGroupInfo.nodeData = typeof nodeData === 'undefined' ? null : nodeData
				this.productPriceGroupInfo.parentData = typeof parentData === 'undefined' ? null : parentData
				this.productPriceGroupInfo.state = 'edit'

				this.showModal({
					component: ProductPriceGroupModify,
					data: this.productPriceGroupInfo,
				})
					.then((result) => {
						this.productPriceGroupInfo.nodeData = result
						this.refresh_productPriceGroups({ force: true })
						$.each(this.treeNodes, (i, node) => {
							if (node.id === this.productPriceGroupInfo.nodeData.id) {
								this.treeNodes.splice(i, 1, $.extend(true, {}, this.productPriceGroupInfo.nodeData))
								this.treeNodes[i].isSelected = true
								this.$refs.treeview.$el.focus()

								this.selectedProductPriceGroup = this.treeNodes[i]
								return false
							}
						})
					})
					.catch(() => {
						this.$refs.treeview.$el.focus()
					})
			},
			deleteProductPriceGroup(node) {
				dialog({
					title: this.$t('sale.product-group.want-to-delete'),
					body: this.$t('sale.product-group.warning-to-delete', {
						name: node.name,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteProductPriceGroupConfirmed(node)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteProductPriceGroupConfirmed(node) {
				if (node.hasChild === true) {
					dialog({
						title: this.$t('sale.product-group-list.delete'),
						body: this.$t('msg.NotDeleted_ChildFound'),
						autoClose: true,
						type: 'error',
					})
				} else {
					post(Endpoints.getUrl('sale.product.price.group.delete'), {
						id: node.id,
					}).then((result) => {
						this.selectedProductPriceGroup = null
						this.refresh_productPriceGroups({ force: true })
						let index = this.treeNodes.findIndex(
							(x) => x.id === node.id
						)
						if (index > -1) {
							this.treeNodes.splice(index, 1)

							if (node.parent) {
								let parent = _.head(
									this.treeNodes.filter(
										(x) => x.id === node.parent.id
									)
								)
								let siblings = this.treeNodes.filter(
									(x) => x.parent && x.parent.id === parent.id
								)

								if (siblings.length > 0) {
									this.selectedProductPriceGroup = siblings[siblings.length - 1]
								} else {
									parent.hasChild = false
									this.selectedProductPriceGroup = parent
								}
							} else {
								this.selectedProductPriceGroup = this.treeNodes[0]
							}
						}
						this.$refs.treeview.$el.focus()
						this.$toast(this.$t('sale.product-group-list.delete-success', {
							name: node.name,
						}), { type: 'success' })
					})
				}
			},
			getParentNodeById(id) {
				var parent = this.treeNodes.filter((x) => x.id === id)
				if (!this.$nikan.isZeroLength(parent)) {
					return parent[0]
				} else {
					return null
				}
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'product-price-group-search',
					shortcut: $sc.find('search'),
					el: this.$el,
					context: this,
					handler: (sender, e) => {
						var searchInput = $(this.$refs.treeview.$el).find('.filter-input')
						if (!this.$nikan.isZeroLength(searchInput)) {
							e.preventDefault()
							$(searchInput[0]).focus()
							return true
						}
					},
				})
			},
			findMaxChildCode(nodeId) {
				let nodes = this.treeNodes

				if (nodeId) {
					nodes = nodes.filter((x) => x.parent && x.parent.id === nodeId)
				} else {
					nodes = nodes.filter((x) => x.parent == null || isEmpty(x.parent.id))
				}

				return nodes
					.map((x) => x.code)
					.reduce((max, current) => (max < current ? current : max), 0)
			},
		},
	}
</script>
<style>
	.group-list .card-body {
		overflow: hidden;
	}
</style>
